let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9ZeC1")).then(() => parcelRequire('4Xn5l'));